import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { Purpose } from 'src/app/core/models/purpose';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-discard-or-save',
    template: `
    <h4 class="text-center">
      Attenzione, hai delle modifiche non salvate.
    </h4>
    <p>Cosa vuoi fare?</p>
    <section class="d-flex justify-content-center mt-4">
      <button class="w-25" mat-flat-button [mat-dialog-close]="false">
        Scarta
      </button>
      <button
        class="ms-3 w-25"
        mat-flat-button
        color="accent"
        [mat-dialog-close]="true"
      >
        Salva
      </button>
    </section>
  `,
    styles: [],
    imports: [MatButton, MatDialogClose]
})
export class DiscardOrSaveComponent {
  data = inject<{
    benefit: Purpose;
}>(MAT_DIALOG_DATA);

}
